<div [ngClass]="{'o' : mappingBoard.showBoard.value}" class="data-mapping-flow-header colored"
     *ngIf="isAvailable(bot) && bot.botType !== 'internal'">
    <div class="row">
        <div class="col-5">
            <div class="strong" [ngClass]="{'d-none' : !(showDatabases.value)}">
                {{ 'eRegistrations Databases' | translate }}
            </div>
        </div>
        <div class="col-2">
            <div class="data-flow-direction">
                <div>
                    <span class="data-flow-direction-arrow mt-2">
                          <i class="fas fa-arrow-{{mappingBoard.isLtr ? 'right' : 'left'}} type" title="{{ 'Data flow direction' | translate }}"></i>
                    </span>
                    <span class="flow-text">{{ requestType | translate }}</span>
                </div>
            </div>
        </div>
        <div class="col-5">
            <div class="full-height d-grid service-select-grid">
                <div>
                    <mapping-checker
                        [mappingBoard]="mappingBoard"
                        [bot]="bot"
                        (showLines)="askForShowingLines($event)"
                        (hideLines)="askForHidingLines($event)"
                        (updateMapping)="deleteGhostMapping($event)"
                        >
                    </mapping-checker>
                    <div *ngIf="checkingNewServiceLinks" class="service-version-indicator">
                        <i class="fa fa-spinner-third fa-spin" tooltip="{{'Checking links updates' | translate}}" placement="left"></i>
                    </div>
                    <div *ngIf="!isLastServiceVersion && bot.botServiceId" class="service-version-indicator">
                        <i class="fad fa-circle-dot text-danger" tooltip="{{'Newer service available' | translate}}" placement="left"></i>
                    </div>
                    <div *ngIf="isLastServiceVersion && bot.botServiceId" class="service-version-indicator">
                        <i class="fad fa-circle-dot text-success" tooltip="{{'Latest service' | translate}}" placement="left"></i>
                    </div>
                    <div *ngIf="!bot.botServiceId" class="service-version-indicator">
                        <i class="fad fa-circle-dot text-warning" tooltip="{{'No service selected' | translate}}" placement="left"></i>
                    </div>
                    <div class="input-container p-0 d-none align-items-center full-height"
                         [ngClass]="{'d-flex' : flexRemoteDatabases}">
                        <search-services
                            class="w-100"
                            *ngIf="bot"
                            (changeValue)="setBotService.emit($event)"
                            [items]="muleServices"
                            [selected]="bot.botServiceId"
                            [formatGDB]="true"
                            [placeholder]="'Select remote database' | translate">
                        </search-services>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <i class="open-toggle far fa-angle-down"
                       (click)="setBoardVisibility.emit({ board: mappingBoard, value: !mappingBoard.showBoard.value, clickHandler: true })"></i>
                </div>
            </div>
        </div>
    </div>
</div>

<div [ngClass]="{'o' : mappingBoard.showBoard.value}" class="data-mapping-flow-header colored"
     *ngIf="isAvailable(bot) && bot.botType === 'internal'">
    <div class="row">
        <div class="col-5">
            <div class="strong" [ngClass]="{'d-none' : !(showDatabases.value)}">
                {{ 'eRegistrations Databases' | translate }}
            </div>
        </div>
        <div class="col-2">
            <div class="data-flow-direction">
                <div>
                    <span class="data-flow-direction-arrow mt-2">
                          <i class="fas fa-arrow-{{mappingBoard.isLtr ? 'right' : 'left'}} type" title="{{ 'Data flow direction' | translate }}"></i>
                    </span>
                    <span class="flow-text">{{ requestType | translate }}</span>
                </div>
            </div>
        </div>
        <div class="col-5">
            <div class="full-height d-grid service-select-grid">
                <div>
                    <mapping-checker
                        [mappingBoard]="mappingBoard"
                        [bot]="bot"
                        (showLines)="askForShowingLines($event)"
                        (hideLines)="askForHidingLines($event)"
                        (updateMapping)="deleteGhostMapping($event)"
                        >
                    </mapping-checker>
                    <div *ngIf="checkingNewServiceLinks" class="service-version-indicator">
                        <i class="fa fa-spinner-third fa-spin" tooltip="{{'Checking links updates' | translate}}" placement="left"></i>
                    </div>
                    <div *ngIf="!isLastServiceVersion && bot.botServiceId" class="service-version-indicator">
                        <i class="fad fa-circle-dot text-danger" tooltip="{{'Newer service available' | translate}}" placement="left"></i>
                    </div>
                    <div *ngIf="isLastServiceVersion && bot.botServiceId" class="service-version-indicator">
                        <i class="fad fa-circle-dot text-success" tooltip="{{'Latest service' | translate}}" placement="left"></i>
                    </div>
                    <div *ngIf="!bot.botServiceId" class="service-version-indicator">
                        <i class="fad fa-circle-dot text-warning" tooltip="{{'No service selected' | translate}}" placement="left"></i>
                    </div>
                    <div class="input-container p-0 d-none align-items-center full-height"
                         [ngClass]="{'d-flex' : flexRemoteDatabases}">
                        <search-services
                            class="w-100"
                            *ngIf="bot"
                            (changeValue)="changeBotService.emit($event)"
                            [items]="allServices"
                            [selected]="bot.botServiceId"
                            [formatGDB]="false"
                            [placeholder]="'Select service' | translate">
                        </search-services>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <i class="open-toggle far fa-angle-down"
                       (click)="setBoardVisibility.emit({ board: mappingBoard, value: !mappingBoard.showBoard.value, clickHandler: true })"></i>
                </div>
            </div>
        </div>
    </div>
</div>

<div [ngClass]="{'hidden' : !(mappingBoard.showBoard.value && isAvailable(bot))}" class="row bg-blue" (window:resize)="onResize($event)">
    <div id="{{mappingBoard.id}}-linesContainer" class="lines-container"></div>
    <div class="col-5 mapping-left">
        <div class="fields-box full-height">
            <div class="input-container">
                <i class="fa fa-search"></i>
                <input type="text" name="name" placeholder="{{ (mappingBoard.isLtr ? 'Search output' : 'Search input') | translate }}"
                       class="form-control search-input"
                       (input)="searchLeftChanged($event.target.value)">
            </div>
            <div class="mapping-tabs new-tabs-container" id="leftTabsContainer-{{mappingBoard.id}}">
                <ul class="nav nav-tabs new-tabs" id="leftTabsList-{{mappingBoard.id}}">
                    <ng-container *ngFor="let group of leftTabs">
                        <li class="{{group.active ? 'active' : ''}}" (click)="setSelectedLeftTab(group)"><span>{{group.name | translate}}</span></li>
                    </ng-container>
                </ul>
                <ul role="tablist" class="nav nav-tabs new-tabs dropdown-tabs d-none" id="leftTabsResp-{{mappingBoard.id}}">
                    <li class="dropdown active" dropdown>
                        <a class="" href="#" (click)="false" dropdownToggle>
                            <ng-container *ngFor="let group of leftTabs">
                                <span *ngIf="group.active">{{group.name | translate}}</span>
                            </ng-container>
                          <i class="fas fa-angle-down ml-3"></i>
                          <i class="fas fa-angle-up ml-3"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-left" *dropdownMenu>
                            <ng-container *ngFor="let group of leftTabs">
                                <a *ngIf="!group.active" (click)="setSelectedLeftTab(group)" class="dropdown-item py-2">
                                    <span>{{ group.name | translate }}</span>
                                </a>
                            </ng-container>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="visibility-container clearfix mt-4 mb-4">
                <div class="l">
                    <div [ngClass]="{'o' : !mappingBoard.collapseFieldsLeft}" class="item"
                         (click)="setLeftCollapse(false)">
                        {{ 'Expand all' | translate }}
                    </div>
                    <div [ngClass]="{'o' : mappingBoard.collapseFieldsLeft}" class="item"
                         (click)="setLeftCollapse(true)">
                        {{ 'Collapse all' | translate }}
                    </div>
                </div>
                <!--<div class="r">
                    <div [ngClass]="{'o' : !mappingBoard.onlyVisibleLeftField}" class="item"
                         (click)="setLeftFieldsVisibility(false)">
                        {{ 'All fields' | translate }}
                    </div>
                    <div [ngClass]="{'o' : mappingBoard.onlyVisibleLeftField}" class="item"
                         (click)="setLeftFieldsVisibility(true)">
                        {{ 'Visible fields' | translate }}
                    </div>
                </div>-->
            </div>
            <div class="scrolled-region leftFields" (scroll)="scroll()">
                <div class="fields-table {{mappingBoard.isLtr ? 'left-to-right-flow' : 'right-to-left-flow'}}">
                    <div class="tree">
                        <tree-branch
                                class="tree-{{mappingBoard.type}}"
                                [branches]="filteredFieldGroups"
                                [selectedTab]="selectedLeftTab"
                                [checkingVisibility]="checkingVisibility"
                                [lines]="mappingBoard.lines"
                                [type]="mappingBoard.type"
                                [leftPrefix]="mappingBoard.leftIdPrefix"
                                [rightPrefix]="mappingBoard.rightIdPrefix"
                                [filter]="mappingBoard.leftFilter"
                                [boardId]="mappingBoard.id"
                                [isLtr]="mappingBoard.isLtr"
                                [dragSrc]="mappingBoard.dragSrc"
                                [isDragging]="mappingBoard.isDragging"
                                [bot]="bot"
                                [showAllFields]="!mappingBoard.onlyVisibleLeftField"
                                (handleScroll)="handleScroll.emit()"
                                (addRelationship)="addRelationship($event)"
                                (updateRelationshipsPositions)="updateRelationshipsPositions.emit($event)"
                                (setSelectedMuleService)="setSelectedMuleService.emit($event)"
                                (removeSelection)="mappingBoard.removeSelection()"
                                (addDataTransformation)="onAddDataTransformation($event)"
                                (saveLines)="saveLines.emit($event)"
                                (removeRelationship)="deleteRTLline($event)"
                        ></tree-branch>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-2 text-center">
        <div *ngIf="requestType === 'query' && mappingBoard.lines.length > 1" class="ml-auto mr-auto fix-username mt-4" (click)="isOTMClosed=false; hideLines.emit();" tooltip="{{'Requests builder' | translate}}" placement="bottom">
            <i class="fad fa-shuffle"></i>
        </div>
        <div *ngIf="showEntriesButton && bot && (requestType === 'write') "
            class="ml-auto mr-auto big-circle-button mt-4 {{hasEntriesDeterminants() ? 'active' : ''}}"
            (click)="openEntriesFilters();"
            tooltip="{{(hasEntriesDeterminants() ? 'Filtered' : 'Entries filters') | translate}}"
            placement="bottom">
            <i class="fad fa-shuffle"></i>
        </div>
    </div>
    <div class="col-5 mapping-right">
        <div class="fields-box full-height">

            <div class="input-container">
                <i class="fa fa-search"></i>
                <input type="text" name="name" placeholder="{{ (mappingBoard.isLtr ? 'Search input' : 'Search output') | translate }}"
                       class="form-control search-input"
                       (input)="bot.botType !== 'internal' ? searchRightChanged($event.target.value) : searchInternalRightChanged($event.target.value)">
            </div>
            <div class="mapping-tabs new-tabs-container" id="rightTabsContainer-{{mappingBoard.id}}">
                <ul class="nav nav-tabs new-tabs" id="rightTabsList-{{mappingBoard.id}}">
                    <li *ngIf="bot.botType !== 'internal'" class="active"><span>{{ "Main" | translate}}</span></li>
                    <ng-container *ngIf="bot.botType === 'internal'">
                        <ng-container *ngFor="let group of rightTabs">
                            <li class="{{group.active ? 'active' : ''}}" (click)="setSelectedRightTab(group)"><span>{{group.name | translate}}</span></li>
                        </ng-container>
                    </ng-container>
                </ul>
                <ul role="tablist" class="nav nav-tabs new-tabs dropdown-tabs d-none" id="rightTabsResp-{{mappingBoard.id}}" *ngIf="bot.botType === 'internal'">
                    <li class="dropdown active" dropdown>
                        <a class="" href="#" (click)="false" dropdownToggle>
                            <ng-container *ngFor="let group of rightTabs">
                                <span *ngIf="group.active">{{group.name | translate}}</span>
                            </ng-container>
                          <i class="fas fa-angle-down ml-3"></i>
                          <i class="fas fa-angle-up ml-3"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-left" *dropdownMenu>
                            <ng-container *ngFor="let group of rightTabs">
                                <a *ngIf="!group.active" (click)="setSelectedRightTab(group)" class="dropdown-item py-2">
                                    <span>{{ group.name | translate }}</span>
                                </a>
                            </ng-container>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="visibility-container clearfix mt-4 mb-4">
                <div class="l">
                    <div [ngClass]="{'o' : !mappingBoard.collapseFieldsRight}" class="item"
                         (click)="setRightCollapse(false)">
                        {{ 'Expand all' | translate }}
                    </div>
                    <div [ngClass]="{'o' : mappingBoard.collapseFieldsRight}" class="item"
                         (click)="setRightCollapse(true)">
                        {{ 'Collapse all' | translate }}
                    </div>
                </div>
                <!--<div class="r">
                    <div [ngClass]="{'o' : !mappingBoard.onlyVisibleRightField}" class="item"
                         (click)="setRightFieldsVisibility(false)">
                        {{ 'All fields' | translate }}
                    </div>
                    <div [ngClass]="{'o' : mappingBoard.onlyVisibleRightField}" class="item"
                         (click)="setRightFieldsVisibility(true)">
                        {{ 'Visible fields' | translate }}
                    </div>
                </div>-->
            </div>
            <div class="clearfix"></div>
            <div class="scrolled-region rightFields r" (scroll)="scroll()">
                <div
                        *ngIf="mappingBoard.showRightSideFields"
                        class="table table-hover {{mappingBoard.isLtr ? 'left-to-right-flow' : 'right-to-left-flow'}}"
                        cdkDropList
                            [cdkDropListData]="fields"
                            (cdkDropListDropped)="dropped($event)">
                    <right-side
                            [bot]="bot"
                            [fields]="fields"
                            [serviceId]="serviceId"
                            [selectedTab]="selectedRightTab"
                            [hideFields]="hideFields"
                            [lines]="mappingBoard.lines"
                            [dragSrc]="mappingBoard.dragSrc"
                            [isDragging]="mappingBoard.isDragging"
                            [generateRightEstructure]="generateRightEstructure"
                            [filter]="mappingBoard.rightFilter"
                            [visible]="!mappingBoard.onlyVisibleRightField"
                            [muleServiceItems]="bot.botType !== 'internal' ? mappingBoard.muleServiceItems : filteredRightFieldGroups"
                            [rightPrefix]="mappingBoard.rightIdPrefix"
                            [leftPrefix]="mappingBoard.leftIdPrefix"
                            [type]="mappingBoard.type"
                            [checkingVisibility]="checkingVisibility"
                            [boardId]="mappingBoard.id"
                            [isLtr]="mappingBoard.isLtr"
                            (handleScroll)="handleScroll.emit()"
                            (addRelationship)="addRelationship($event)"
                            (setSelectedMuleService)="setSelectedMuleService.emit($event)"
                            (saveLines)="saveLines.emit($event)"
                            (removeSelection)="mappingBoard.removeSelection()"
                            (removeRelationship)="mappingBoard.removeRelationship($event); deleteLTRline($event);"
                            (updateHiddenServiceFields)="updateHiddenServiceFields.emit()"
                            (addDataTransformation)="onAddDataTransformation($event)"
                    ></right-side>
                </div>
            </div>
        </div>
    </div>
</div>

<drawer *ngIf="requestType === 'query' && bot && mappingBoard.lines.length > 1 && !isOTMClosed" [title]="'Requests builder'" (saveEvent)="saveRequestsBuilder()" [isClosed]="isOTMClosed" (closeEvent)="isOTMClosed = !isOTMClosed; showLines.emit();">
    <one-to-many-query [lines]="mappingBoard.lines" [isLtr]="mappingBoard.isLtr" (saveQuery)="saveQuery($event)" [conditions]="bot.inputQueryFilter" (close)="isOTMClosed = !isOTMClosed; showLines.emit();"></one-to-many-query>
</drawer>